import { render, staticRenderFns } from "./ThankYouForSharingYourProject.vue?vue&type=template&id=7f2244f8"
import script from "./ThankYouForSharingYourProject.vue?vue&type=script&lang=ts"
export * from "./ThankYouForSharingYourProject.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports